import { observer } from 'mobx-react-lite';
import React from 'react';
import { TradePlanData } from '../../../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../../../classes/tradePlan/tradePlanProvider';
import { colors } from '../../../../../../../../colorVars';
import { Dropdown } from '../../../../../../../atomic/atomicComponentLibrary/dropdown/Dropdown';
import { NumericalInput } from '../../../../../../../atomic/atomicComponentLibrary/numericalInput/NumericalInput';
import { Body3, Body4, fontSizes } from '../../../../../../../atomic/text/Text';
import style from '../SimpleTacticStyle.module.css';

type Props = {
  candleDuration: number;
  timeUnit: string;
};

export const SimpleAtrTrail = observer(
  ({ candleDuration, timeUnit }: Props) => {
    const tradePlanForm: TradePlanData = useTradePlanFormStore();
    const defaultFn = () => {};
    const isEnabled = tradePlanForm.exitTactics.ATR_TRAIL ?? false;
    const candleDurationValue =
      tradePlanForm.exitTactics.ATR_TRAIL?.candleDuration ?? 1;
    const setCandleDurationValue =
      tradePlanForm.exitTactics.ATR_TRAIL?.setCandleDuration ?? defaultFn;
    const timeUnitValue = tradePlanForm.exitTactics.ATR_TRAIL?.timeUnit ?? 1;
    const setTimeUnitValue =
      tradePlanForm.exitTactics.ATR_TRAIL?.setTimeUnit ?? defaultFn;
    const pctOfAtr = tradePlanForm.exitTactics.ATR_TRAIL?.pctOfAtr ?? 300;
    const setPctOfAtr =
      tradePlanForm.exitTactics.ATR_TRAIL?.setPctOfAtr ?? defaultFn;

    return (
      <div className={style.container}>
        <div className={style.labelAndCheckbox}>
          <input
            style={{ margin: '0 5px 0 0' }}
            type="checkbox"
            checked={isEnabled}
            onChange={() => {
              if (isEnabled) {
                tradePlanForm.removeExitTactic('ATR_TRAIL');
              } else {
                tradePlanForm.addExitTactic('ATR_TRAIL', {
                  candleDuration,
                  timeUnit,
                });
              }
            }}
          />
          <Body3 fontWeight={700} color={colors.lightGrey}>
            ATR Trail
          </Body3>
        </div>
        <div className={style.controlsThreeLargerCenter}>
          <div className={style.labelAndControl}>
            <Body4 color={colors.lightGrey}>Duration</Body4>
            <NumericalInput
              disabled={!isEnabled}
              width="30px"
              maxHeight="23px"
              fontSize={fontSizes.body4}
              fontColor="white"
              backgroundColor="grey"
              controlledValue={candleDurationValue}
              onChange={setCandleDurationValue}
            />
          </div>
          <div className={style.labelAndControl}>
            <Body4 color={colors.lightGrey}>Time Unit</Body4>
            <Dropdown
              fontSize={fontSizes.body4}
              color="white"
              backgroundColor="grey"
              value={timeUnitValue}
              onChange={setTimeUnitValue}
            >
              <option value="MINUTES">Minutes</option>
              <option value="DAYS">Days</option>
              <option value="WEEKS">Weeks</option>
              <option value="MONTHS">Months</option>
              <option value="QUARTERS">Quarters</option>
              <option value="YEARS">Years</option>
            </Dropdown>
          </div>
          <div className={style.labelAndControl}>
            <Body4 color={colors.lightGrey}>% of ATR</Body4>
            <NumericalInput
              icon="%"
              disabled={!isEnabled}
              width="30px"
              maxHeight="23px"
              fontSize={fontSizes.body4}
              fontColor="white"
              backgroundColor="grey"
              controlledValue={pctOfAtr}
              onChange={setPctOfAtr}
            />
          </div>
        </div>
      </div>
    );
  }
);
